import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  CreditCard,
  CheckCircle,
  AlertCircle,
  Clock,
  RefreshCw,
} from 'lucide-angular';
import { BillingService } from '../../../../core/services/billing.service';
import { CustomerBillingDto } from '../../../../core/models/admin.models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-settings-billing',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, TranslatePipe],
  templateUrl: './billing.component.html',
})
export class SettingsBillingComponent implements OnInit {
  private billingService = inject(BillingService);
  private readonly destroyRef = inject(DestroyRef);

  billing = signal<CustomerBillingDto | null>(null);
  loading = signal(true);
  error = signal('');

  CreditCard = CreditCard;
  CheckCircle = CheckCircle;
  AlertCircle = AlertCircle;
  Clock = Clock;
  RefreshCw = RefreshCw;

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading.set(true);
    this.error.set('');
    this.billingService
      .getMyBilling()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          if (res.success) this.billing.set(res.data);
          this.loading.set(false);
        },
        error: () => {
          this.error.set("Ma'lumot yuklanmadi");
          this.loading.set(false);
        },
      });
  }

  formatDate(d: string | null | undefined): string {
    if (!d) return '';
    return new Date(d).toLocaleDateString('uz-UZ');
  }

  formatMoney(n: number | null | undefined): string {
    if (n == null) return '';
    return n.toLocaleString('uz-UZ') + ' UZS';
  }

  daysRemaining(): number | null {
    const b = this.billing();
    if (!b?.subscriptionEndDate) return null;
    const diff = new Date(b.subscriptionEndDate).getTime() - Date.now();
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  }

  isExpired(): boolean {
    const days = this.daysRemaining();
    return days !== null && days < 0;
  }

  isExpiringSoon(): boolean {
    const days = this.daysRemaining();
    return days !== null && days >= 0 && days <= 7;
  }
}
